import { AuraConversation } from '@/types/models/AuraConversationModel';
import { AuraMessage } from '@/types/models/AuraMessageModel';
import { AuraFilters } from '@/types/models/AuraFiltersModel';

export interface AuraState {
    conversations: AuraConversation[];
    currentConversation: AuraConversation | null;
    messages: AuraMessage[];
    activeFilters: AuraFilters | null;
    isLoading: boolean;
    error: string | null;
    isEnabled: boolean | null;
    verticalActivatedAt: string | null;
    isFiltersPanelOpen: boolean;
    validationError: {
        type: string;
        message: string;
        suggestion?: string;
    } | null;
    temporalConflict: {
        questionPeriod: string;
        filterPeriod: string;
        details?: string;
        suggestedDateFrom?: string;
        suggestedDateTo?: string;
    } | null;
    validationStep:
        | 'idle'
        | 'validating_scope'
        | 'classifying_intent'
        | 'checking_temporal'
        | 'processing';
    availableAgents: Array<{ id: number; name: string }>;
    availableQueues: Array<{ id: number; name: string }>;
    hasAuxiliaryFilterLoadFailure: boolean;
}
